import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import FinanciarFunctions from './FinanciarFunctions';
import InterpretareComponent1 from './InterpretareComponent1';
import InterpretareLabelComponent from './InterpretareLabelComponent';


export default class RataRentabilitatiiEconomice extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            arrow1: false,
            arrow2: false,
            arrow3: false,
        }
    }

    f = new FinanciarFunctions()

    componentDidMount() {
    }

    displayArrow = (arr) => {

        this.setState({ [arr]: true })
    }
    render() {
        return (
            <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.rataRentabilitatiiEconomice} </h5>



                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    {this.props.bilanturiDesc &&
                        <InterpretareComponent1
                            labels={[this.dictionary.financiar.slab, this.dictionary.financiar.mediu, this.dictionary.financiar.foarteBine]}

                            arrow1={this.state.arrow1}
                            arrow2={this.state.arrow2}
                            arrow3={this.state.arrow3}
                            displayArrow={this.displayArrow}
                            val1={this.f.rataRentabilitatiiEconomice(this.props.bilanturiDesc[0])}
                            val2={null}
                            cF1={25}
                            cF2={27}
                        />
                    }
                </Grid>

                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>

                    {this.props.bilanturiDesc &&
                        <InterpretareLabelComponent
                            slab={this.dictionary.financiar.slab}
                            mediu={this.dictionary.financiar.mediu}
                            foarteBine={this.dictionary.financiar.foarteBine}
                            dictionary={this.dictionary}
                            subtitle={this.dictionary.financiar.rataRentabilitatiiEconomice}
                            val1={this.f.rataRentabilitatiiEconomice(this.props.bilanturiDesc[0])}
                            val2={null}
                            cF1={25}
                            cF2={27}
                        />
                    }

                </Grid>

            </Grid>
        );
    }
}